import React, { useEffect, useState } from 'react'
import Styles from './styles.module.sass';
import { useHistory } from 'react-router-dom'

import CardElegirTarjeta from 'newComponents/Cards/ModuleCardPay'

import { useCardsListT1 } from 'newHooks/useCardsT1'
import { useIsMobile } from 'newHooks/useIsMobile';
import { decodeStorage } from 'newFunctions/storageBase64'

import Loading from 'newComponents/Loading'
import MainLayout from 'newComponents/Layout/MainLayout';
import CreditoLayout from 'newComponents/Layout/CreaditoLayout';
import SectionLayout from 'newComponents/Layout/SectionLayout';
import { BASE_PATH, SUB_DIRECTORY } from 'constants/general'


const ElegirTarjeta = () => {
    const history = useHistory();
    const [ data, setData ] = useState()
    const { isMobile } = useIsMobile();
    const payCardRelation = decodeStorage('payCardRelation')

    const { cardsArray, updateArrayCards } = useCardsListT1()
    const [ loading, setLoading ] = useState(true)

    //- Codigo de instana para track de pagina 
    useEffect(()=>{
        // window.ineum('page', 'Choise Payment Card Credit-Page')
        // window.ineum('meta', 'portal', 'Credito')
    },[])

    useEffect(()=>{
        if(!payCardRelation){
            history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
        }
    },[])
    
    const returnBack = () => {
        history.replace(`${BASE_PATH}${SUB_DIRECTORY}pagar-tarjeta`);
    }

    useEffect(()=>{
        if(cardsArray){
            if(cardsArray.length === 0){
                history.push(`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta-bancaria`);
            }
            else{
                setLoading(false)
            }
        }
    },[cardsArray ])


    const updatePage = () =>{
        updateArrayCards(true)
    }

    let visa = 'newImages/visa.svg';
    let master = 'newImages/mastercard.svg';
    let amex = 'newImages/amex.png';

    const handleAddCardBank = () => {
        history.push(`${BASE_PATH}${SUB_DIRECTORY}agregar-tarjeta-bancaria`);
    };

    const [cardActive, setCadrActive] = useState()
    useEffect(()=>{},[cardActive])

    return (
        <MainLayout>
            <CreditoLayout setData={setData} >
                { loading && <Loading /> }
                <SectionLayout title="PAGAR TARJETA" >
                    <div className={Styles?.contArrayCards}>
                        <p className={Styles?.h2}>Pagar con tarjeta</p>
                        <div className={Styles?.contCreditCards}>
                            {cardsArray &&
                                cardsArray.map((singleCard,ind) =>
                                    <CardElegirTarjeta
                                        key={singleCard.token}
                                        nombre={singleCard.nombre}
                                        terminacion={singleCard.terminacion}
                                        vencimiento={singleCard.expiracion_mes+'/'+singleCard.expiracion_anio}
                                        tipoTarjeta={singleCard.marca}
                                        logo={singleCard.marca === "visa" ? visa : singleCard.marca === "mastercard" ? master : amex}
                                        id={singleCard.token}
                                        dataCard={singleCard}
                                        update={updatePage}
                                        setCadrActive={setCadrActive}
                                        cardActive={cardActive}
                                        position={ind}
                                        setLoading={setLoading}
                                    />
                            )}
                        </div>
                    </div>
                </SectionLayout>

                <div className={Styles?.contCardsButtons}>
                    <p className={Styles?.btnGris} onClick={returnBack}>Regresar</p>

                    {cardsArray &&
                        <p className={Styles?.btnBlanco} onClick={handleAddCardBank}>Agregar tarjeta</p>
                    }
                </div>

            </CreditoLayout>
        </MainLayout>
    )
}

export default ElegirTarjeta;